module.exports = __webpack_public_path__ + "static/media/29ADMSPC4.eddb43ae.jpg";